export default __webpack_public_path__ + "static/media/header-logo.42f94d22.svg";